import { Component, Input, type OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'

@Component({
  selector: 'app-automation-time-options',
  templateUrl: './automation-time-options.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AutomationTimeOptionsComponent implements OnInit {
  @Input() form: UntypedFormGroup
  @Input() showLabel = true
  ngOnInit(): void {}
}
